import type { SingleAction } from './types';
import styled from '@emotion/styled';
import { breakpoints } from '__app/spacing';
import { fontWeights } from '__app/typography';
import Button from '__components/Button';
import { _modalSize } from 'components/Modals';

type ActionButtonsProps = {
  performActionOptions: SingleAction[];
  onSelect(data: SingleAction): void;
};

export const ActionButton = styled(Button)`
  && {
    padding: 0 15px;
  }
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 15px;

  button {
    width: calc((100% - 40px) / 3);
    height: 35px;
    max-width: unset;
    margin: 0;
    padding: 0;
    letter-spacing: 0.5px;
    line-height: 35px;
    font-weight: ${fontWeights.black};
    border-width: 1px;

    @media (max-width: ${_modalSize.medium - 1}px) {
      width: calc((100% - 20px) / 2);
    }

    @media (max-width: ${breakpoints.sm}px) {
      width: 100%;
    }
  }
`;

export const ActionButtons = (props: ActionButtonsProps) => {
  const { onSelect, performActionOptions } = props;

  return (
    <>
      {performActionOptions.map((option) => (
        <ActionButton
          key={option.value}
          color="blue"
          variant="outline"
          onClick={() => onSelect(option)}
        >
          {option.label}
        </ActionButton>
      ))}
    </>
  );
};
